import { clsx } from '@alexis/helpers/clsx';
import React from 'react';

import styles from './Checkbox.module.scss';

export interface CheckboxProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  className?: string;
  isChecked: boolean;
  onClick?(): void;
  style?: React.CSSProperties;
}

const Checkbox: React.FC<CheckboxProps> = ({
  className,
  style,
  isChecked,
  onClick,
  ...props
}): JSX.Element => {
  return (
    <div
      role='checkbox'
      aria-checked={isChecked}
      className={clsx(styles.container, isChecked && styles.checked, className)}
      style={style}
      onClick={onClick}
      {...props}
    ></div>
  );
};

export default Checkbox;
